class C4BessEllipse {

  static DEFAULT_SELECTOR_ID = "";

  constructor(data, selector_id = C4BessEllipse.DEFAULT_SELECTOR_ID) {
    this.data = data;
    this.selector_id = selector_id ?? C4BessEllipse.DEFAULT_SELECTOR_ID;
    this.selector = `table#bess-timeline-${this.selector_id}`;


    this.table = document.querySelector(this.selector);

    if (!this.table) return;

    this.init();
  }

  init() {
    window.addEventListener("load", () => {
      this.initializeCanvas(this.data);
    });
  }

  initializeCanvas(data) {

    var baselineIndex;

    if(data.assessments)
      {
        var stance_matched = false;
        var assessments_array = new Array();
        var temp_string = '';
        data.canvas_width = Math.floor((($(this.selector).width()) - (8) - (102) - (6 * 8)) / 6);
        data.canvas_height = Math.floor(data.canvas_width * .75);
        data.stance_array_old = ['Double Leg','Single Leg','Tandem','Double Leg On Pad','Single Leg On Pad','Tandem On Pad'];
        data.stance_array_new = ['Double Leg Eyes Closed','Single Leg Eyes Closed','Tandem Eyes Closed','Double Leg On Pad Eyes Closed','Single Leg On Pad Eyes Closed','Tandem On Pad Eyes Closed'];

        // FIND BASELINE
        for(let i = 0; i < data.assessments.length; i++){
          if(data.assessments[i].baseline == true){
            baselineIndex = i;
            break;
          }
        }// END FIND BASELINE

        // SORT ASSESSMENTS
        if(data.baseline_included == true){

          for(let j = 0; j < data.assessments.length; j++){
            if(data.assessments[j].baseline != true){
              assessments_array.push(data.assessments[j]);
            }
          }
          assessments_array.push(data.assessments[baselineIndex]);
          data.assessments = assessments_array;
        }// END SORT ASSESSMENTS

        // FOR ASSESSMENTS
        for(let i = 0; i < data.assessments.length; i++){
          data.assessments[i].bess_test_indices = [-1,-1,-1,-1,-1,-1];
          if(data.baseline_included == true && data.assessments[i].baseline == true){
            temp_string += '<tr class="table-success"><td class="bess-assessment">';
          }else{
            temp_string += '<tr><td class="bess-assessment">';
          }

          temp_string += data.assessments[i].complete_time.split("T")[0];
          temp_string += '<br>';
          if(data.baseline_included == true && data.assessments[i].baseline == true){
            temp_string += 'BASELINE';
          }else{
            temp_string += 'FOLLOW-UP';
          }
          temp_string += '</td>';

          // FOR STANCES
          for(let j = 0; j < data.stance_array_new.length; j++){
            stance_matched = false;
            // FOR BESS TESTS
            for(let k = 0; k < data.assessments[i].bess_tests.length; k++){
            // IF STANCES MATCH
            if((data.assessments[i].bess_tests[k].stance == data.stance_array_old[j] || data.assessments[i].bess_tests[k].stance == data.stance_array_new[j]) && !isNaN(data.assessments[i].bess_tests[k].elliptical_volume)){
              data.assessments[i].bess_test_indices[j] = k;
              // BUILD TD
              temp_string += '<td><div class="errors"><span id="';
              temp_string += `errors${this.selector_id}_`;
              temp_string += i;
              temp_string += '_';
              temp_string += j;
              temp_string += '">';
              temp_string += data.assessments[i].bess_tests[k].error_count;
              temp_string += '</span> ';

              if(data.assessments[i].bess_tests[k].error_count == 1){
                temp_string += 'Error';
              }else{
                temp_string += 'Errors';
              }

              temp_string += '</div><div class="volume">Vol. Percentile: <span id="';
              temp_string += `volume${this.selector_id}_`;
              temp_string += i;
              temp_string += '_';
              temp_string += j;
              temp_string += '">';
              temp_string += data.assessments[i].bess_tests[k].volume_percentile;
              temp_string += '</span></div>';
              temp_string += '<div class="clear-both"></div>';
              temp_string += `<canvas id="ellipse${this.selector_id}_`;
              temp_string += i;
              temp_string += '_';
              temp_string += j;//data.canvas_width
              temp_string += '" width="';
              temp_string += data.canvas_width;
              temp_string += '" height="';
              temp_string += data.canvas_height;
              temp_string += '">';
              temp_string += 'Your browser does not support the HTML5 canvas tag.</canvas>';
              temp_string += '</td>';
              // END BUILD TD
              stance_matched = true;
              break;// STANCE MATCHED, CANVAS BUILT
            }// END IF STANCES MATCH
            }// END FOR BESS TESTS
            // IF STANCE NOT MATCHED
            if(stance_matched == false){
              temp_string += '<td class="no_data">NO DATA</td>';
            }// END IF STANCE NOT MATCHED
          }// END FOR STANCES


          temp_string += '</tr>';
          console.log("selectah: ", this.selector);


          $(this.selector).append(temp_string);

          temp_string = '';
        }// END FOR ASSESSMENTS
      }else{
        $(this.selector).append('<tr><td colspan="7" scope="col">No Assessments Available</td></tr>');
      }

    this.setupEllipses(data);
  }

  setupEllipses(data){
    var i;
    var j;
    var k;
    var ml_temp = 0;
    var tr_temp = 0;
    var ap_temp = 0;
    var ml_assessment_temp = 0;
    var tr_assessment_temp = 0;
    var ap_assessment_temp = 0;
    data.perspective_angle = 20;
    data.axes_padding = 40;
    data.ellipse_padding = data.axes_padding + 40;
    data.ml_max_radius_stance = [0,0,0,0,0,0];
    data.tr_max_radius_stance = [0,0,0,0,0,0];
    data.ap_max_radius_stance = [0,0,0,0,0,0];
    data.max_radius_stance = [0,0,0,0,0,0];
    data.max_volume_stance = [-1000,-1000,-1000,-1000,-1000,-1000];
    data.major_axis_stance = ["tr","tr","tr","tr","tr","tr"];
    data.px_per_stance = [0,0,0,0,0,0];
    data.px_readings_per_stance = [0,0,0,0,0,0];
    var tuples_array = [];
    var temp_array = [];
    var readings_by_stance_array = [[[],[],[]],[[],[],[]],[[],[],[]],[[],[],[]],[[],[],[]],[[],[],[]]];

    // FOR ASSESSMENTS
    for(i = 0; i < data.assessments.length; i++){
      // FOR STANCES
      for(j = 0; j < 6; j++){
        if(data.assessments[i].bess_test_indices[j] > -1){
          // REFORMAT READINGS
          // 0.000,0.000,0.000; 0.010,0.010,0.010;
          if(typeof data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha == "undefined"){
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha = "0,0,0;";
          }else if(data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha == null){
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha = "0,0,0;";
          }else if(data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha == ""){
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha = "0,0,0;";
          }
          tuples_array = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_dataha.split(";");
          // TRIM TRAILING TUPLE DELIMITER
          if(tuples_array[tuples_array.length-1].length == 0){
            tuples_array.length = tuples_array.length - 1;
          }
          temp_array = [];
          temp_array[0] = [0,0,0];
          data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_array = [];
          data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_array.push(temp_array[0]);
          for(k = 1; k < tuples_array.length; k++){
            temp_array[k] = tuples_array[k].split(",");
            temp_array[k][0] = Number(temp_array[k][0]);
            temp_array[k][1] = Number(temp_array[k][1]);
            temp_array[k][2] = Number(temp_array[k][2]);
            readings_by_stance_array[j][0].push(temp_array[k][0]);
            readings_by_stance_array[j][1].push(temp_array[k][1]);
            readings_by_stance_array[j][2].push(temp_array[k][2]);
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_array.push(temp_array[k]);
          }
          // END REFORMAT READINGS

          // FPO TRY REMAPPING RADII
          var swap_axes = false;
          if(typeof data.axis_flip == "undefined"){
            swap_axes = false;
          }else{
            swap_axes = data.axis_flip;
          }
          if(swap_axes == true){
            var ml_try = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ml_radius;
            var ap_try = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ap_radius;
            var tr_try = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].tr_radius;
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ml_radius = ap_try;
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ap_radius = ml_try;
            data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].tr_radius = tr_try;
          }// END FPO TRY REMAPPING RADII

          // FIND MAX ASSESSMENT RADII FIX ME
          if(data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ml_radius > ml_assessment_temp){
            ml_assessment_temp = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ml_radius;
          }
          if(data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].tr_radius > tr_assessment_temp){
            tr_assessment_temp = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].tr_radius;
          }
          if(data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ap_radius > ap_assessment_temp){
            ap_assessment_temp = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ap_radius;
          }// END FIND MAX ASSESSMENT RADII
          // FIND MAX VOLUME FOR MAX STANCE RADII
          if(data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].elliptical_volume_ln > data.max_volume_stance[j]){
            data.max_volume_stance[j] = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].elliptical_volume_ln;
            data.ml_max_radius_stance[j] = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ml_radius;
            data.tr_max_radius_stance[j] = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].tr_radius;
            data.ap_max_radius_stance[j] = data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ap_radius;
            if(data.ml_max_radius_stance[j] == data.ap_max_radius_stance[j]){
              data.major_axis_stance[j] = "tr";
            }else if(data.ml_max_radius_stance[j] > data.ap_max_radius_stance[j]){
              data.major_axis_stance[j] = "ml";
            }else{
              data.major_axis_stance[j] = "ap";
            }

          }
          // END FIND MAX VOLUME FOR MAX STANCE RADII
          // FIND MAX ALL RADII FIX ME
          if(ml_assessment_temp > ml_temp){
            ml_temp = ml_assessment_temp
          }
          if(tr_assessment_temp > tr_temp){
            tr_temp = tr_assessment_temp
          }
          if(ap_assessment_temp > ap_temp){
            ap_temp = ap_assessment_temp
          }// END FIND MAX ALL RADII
        }
      }// END FOR STANCES
      // SET MAX AND PIXEL DATA FOR ASSESSMENTS FIX ME
      if(ml_assessment_temp + ap_assessment_temp >= tr_assessment_temp * 2){
        data.assessments[i].max_radius = (ml_assessment_temp + ap_assessment_temp) * .5;
      }else{
        data.assessments[i].max_radius = tr_assessment_temp;
      }
      data.assessments[i].px_per_assessment = Math.ceil((data.canvas_height - data.axes_padding) / (data.assessments[i].max_radius * 2));
      data.assessments[i].ml_max_radius = ml_assessment_temp;
      data.assessments[i].tr_max_radius = tr_assessment_temp;
      data.assessments[i].ap_max_radius = ap_assessment_temp;
      ml_assessment_temp = 0;
      tr_assessment_temp = 0;
      ap_assessment_temp = 0;// END SET MAX AND PIXEL DATA FOR ASSESSMENTS
    }// END FOR ASSESSMENTS
    // SET PIXEL DATA FOR READINGS PLOTS
    var max_ap = 0;
    var min_ap = 0;
    var max_ml = 0;
    var min_ml = 0;
    var max_tr = 0;
    var min_tr = 0;
    //data.px_readings_per_stance = [0,0,0,0,0,0];
    // FOR STANCES
    //zxy ml,ap,tr, 0,1,2
    for(i = 0; i < 6; i++){
      if(readings_by_stance_array[i][0].length > 0){
        min_ml = Math.min.apply(Math, readings_by_stance_array[i][0]);
        max_ml = Math.max.apply(Math, readings_by_stance_array[i][0]);
        min_ap = Math.min.apply(Math, readings_by_stance_array[i][1]);
        max_ap = Math.max.apply(Math, readings_by_stance_array[i][1]);
        min_tr = Math.min.apply(Math, readings_by_stance_array[i][2]);
        max_tr = Math.max.apply(Math, readings_by_stance_array[i][2]);
      }
      if( ( (max_ml - min_ml) + (max_ap - min_ap) ) >= (max_tr - min_tr) * 2 ){
        data.px_readings_per_stance[i] = Math.ceil((data.canvas_height - data.axes_padding) / (((max_ml - min_ml) + (max_ap - min_ap)) * .5));
      }else{
        data.px_readings_per_stance[i] = Math.ceil((data.canvas_height - data.axes_padding) / (max_tr - min_tr));
      }
      max_ap = 0;
      min_ap = 0;
      max_ml = 0;
      min_ml = 0;
      max_tr = 0;
      min_tr = 0;
    }// END FOR STANCES
    // END SET PIXEL DATA FOR READINGS PLOTS
    // SET MAX AND PIXEL DATA FOR STANCES
    // FOR STANCES
    for(i = 0; i < 6; i++){
      if(data.ml_max_radius_stance[i] + data.ap_max_radius_stance[i] >= data.tr_max_radius_stance[i] * 2){
        data.max_radius_stance[i] = (data.ml_max_radius_stance[i] + data.ap_max_radius_stance[i]) * .5;
      }else{
        data.max_radius_stance[i] = data.tr_max_radius_stance[i];
      }
      data.px_per_stance[i] = Math.ceil((data.canvas_height - data.axes_padding) / (data.max_radius_stance[i] * 2));
    }// END FOR STANCES
    // END SET MAX AND PIXEL DATA FOR STANCES

    // SET MAX AND PIXEL DATA FOR ALL FIX ME
    data.ml_max_radius = ml_temp;
    data.tr_max_radius = tr_temp;
    data.ap_max_radius = ap_temp;

    if(ml_temp + ap_temp >= tr_temp * 2){
      data.max_radius = (ml_temp + ap_temp) * .5;
    }else{
      data.max_radius = tr_temp;
    }
    data.px_per_all = Math.ceil((data.canvas_height - data.axes_padding) / (data.max_radius * 2));
    // END SET MAX AND PIXEL DATA FOR ALL

    var show_summaries = false;
    if(show_summaries == true){
      // DRAW SUMMARIES FIX ME

      var summary_size_multiplier = 3;
      var canvas_summary_sway = $('#summary_sway' )[0];
      var canvas_summary_errors = $('#summary_errors' )[0];
      canvas_summary_sway.width = 1;
      canvas_summary_sway.height = 1;
      canvas_summary_sway.width = Math.floor(data.canvas_width * summary_size_multiplier);
      canvas_summary_sway.height = Math.floor(data.canvas_height * (summary_size_multiplier * .75) + 50);
      ctx_summary_sway = canvas_summary_sway.getContext('2d');
      canvas_summary_errors.width = 1;
      canvas_summary_errors.height = 1;
      canvas_summary_errors.width = Math.floor(data.canvas_width * summary_size_multiplier);
      canvas_summary_errors.height = Math.floor(data.canvas_height * (summary_size_multiplier * .75) + 50);
      ctx_summary_errors = canvas_summary_errors.getContext('2d');

      // GET VOLUME RANGE, MIN, MAX
      var volumes_array = [];
      var volumes_range = 0;
      // FOR ASSESSMENTS
      for(i = 0; i < data.assessments.length; i++){
        // FOR BESS TESTS
        for(j = 0; j < data.assessments[i].bess_tests.length; j++){
          volumes_array.push(data.assessments[i].bess_tests[j].elliptical_volume)
        }// END FOR BESS TESTS
      }// END FOR ASSESSMENTS
      volumes_array.sort(function(a,b){return a-b});
      volumes_range = (Math.ceil(volumes_array[volumes_array.length - 1]) - Math.floor(volumes_array[0]));
      // END GET VOLUME RANGE, MIN, MAX

      // GET ERRORS RANGE, MIN, MAX
      var errors_array = [];
      var errors_range = 0;
      // FOR ASSESSMENTS
      for(i = 0; i < data.assessments.length; i++){
        // FOR BESS TESTS
        for(j = 0; j < data.assessments[i].bess_tests.length; j++){
          errors_array.push(data.assessments[i].bess_tests[j].error_count)
        }// END FOR BESS TESTS
      }// END FOR ASSESSMENTS
      errors_array.sort(function(a,b){return a-b});
      errors_range = ((errors_array[errors_array.length - 1]) - (errors_array[0]));
      // END GET ERRORS RANGE, MIN, MAX

      var img;
      img = $("#fig_h50_d")[0];
      var chart_pad_top = 30;
      var chart_pad_right = 60;
      var chart_pad_bottom = img.height + 25;
      var chart_pad_left = 60;
      var chart_width = canvas_summary_sway.width - chart_pad_left - chart_pad_right;
      var chart_height = canvas_summary_sway.height - chart_pad_top - chart_pad_bottom;
      var stance_x_array = [
      Math.floor(chart_width * 1/7) + chart_pad_left,
      Math.floor(chart_width * 2/7) + chart_pad_left,
      Math.floor(chart_width * 3/7) + chart_pad_left,
      Math.floor(chart_width * 4/7) + chart_pad_left,
      Math.floor(chart_width * 5/7) + chart_pad_left,
      Math.floor(chart_width * 6/7) + chart_pad_left,
      ]
      var px_per_tick_sway = Math.floor(chart_height / volumes_range);
      var px_per_tick_errors = Math.floor(chart_height / errors_range);

      // DRAW STANCE IMAGES
      // 16 x 50
      ctx_summary_sway.drawImage(img, stance_x_array[0] - (img.width * .5), canvas_summary_sway.height - chart_pad_bottom + 10);
      ctx_summary_errors.drawImage(img, stance_x_array[0] - (img.width * .5), canvas_summary_errors.height - chart_pad_bottom + 10);
      img = $("#fig_h50_s")[0];
      ctx_summary_sway.drawImage(img, stance_x_array[1] - (img.width * .5), canvas_summary_sway.height - chart_pad_bottom + 10);
      ctx_summary_errors.drawImage(img, stance_x_array[1] - (img.width * .5), canvas_summary_errors.height - chart_pad_bottom + 10);
      img = $("#fig_h50_t")[0];
      ctx_summary_sway.drawImage(img, stance_x_array[2] - (img.width * .5), canvas_summary_sway.height - chart_pad_bottom + 10);
      ctx_summary_errors.drawImage(img, stance_x_array[2] - (img.width * .5), canvas_summary_errors.height - chart_pad_bottom + 10);
      img = $("#fig_h50_dp")[0];
      ctx_summary_sway.drawImage(img, stance_x_array[3] - (img.width * .5), canvas_summary_sway.height - chart_pad_bottom + 10);
      ctx_summary_errors.drawImage(img, stance_x_array[3] - (img.width * .5), canvas_summary_errors.height - chart_pad_bottom + 10);
      img = $("#fig_h50_sp")[0];
      ctx_summary_sway.drawImage(img, stance_x_array[4] - (img.width * .5), canvas_summary_sway.height - chart_pad_bottom + 10);
      ctx_summary_errors.drawImage(img, stance_x_array[4] - (img.width * .5), canvas_summary_errors.height - chart_pad_bottom + 10);
      img = $("#fig_h50_tp")[0];
      ctx_summary_sway.drawImage(img, stance_x_array[5] - (img.width * .5), canvas_summary_sway.height - chart_pad_bottom + 10);
      ctx_summary_errors.drawImage(img, stance_x_array[5] - (img.width * .5), canvas_summary_errors.height - chart_pad_bottom + 10);
      // END DRAW STANCE IMAGES

      // DRAW TITLE
      ctx_summary_sway.font = "bold 16px sans-serif";
      ctx_summary_sway.textAlign = "center";
      ctx_summary_sway.textBaseline = "top";
      ctx_summary_sway.fillStyle = 'rgba(0, 0, 0, 1.0)';
      ctx_summary_sway.fillText("Postural Sway", canvas_summary_sway.width * .5, 0);

      ctx_summary_errors.font = "bold 16px sans-serif";
      ctx_summary_errors.textAlign = "center";
      ctx_summary_errors.textBaseline = "top";
      ctx_summary_errors.fillStyle = 'rgba(0, 0, 0, 1.0)';
      ctx_summary_errors.fillText("Balance Errors", canvas_summary_errors.width * .5, 0);
      // END DRAW TITLE

      // DRAW VERTICAL AXIS LABEL
      ctx_summary_sway.font = "normal 12px sans-serif";
      ctx_summary_sway.textAlign = "center";
      ctx_summary_sway.textBaseline = "top";
      ctx_summary_sway.fillStyle = 'rgba(0, 0, 0, 1.0)';
      ctx_summary_sway.save();
      ctx_summary_sway.rotate(-90*Math.PI/180);
      ctx_summary_sway.fillText("Ellipsoid Volume", (0 - (canvas_summary_sway.height * .5)), 0);
      ctx_summary_sway.restore();

      ctx_summary_errors.font = "normal 12px sans-serif";
      ctx_summary_errors.textAlign = "center";
      ctx_summary_errors.textBaseline = "top";
      ctx_summary_errors.fillStyle = 'rgba(0, 0, 0, 1.0)';
      ctx_summary_errors.save();
      ctx_summary_errors.rotate(-90*Math.PI/180);
      ctx_summary_errors.fillText("Errors", (0 - (canvas_summary_errors.height * .5)), 0);
      ctx_summary_errors.restore();
      // END VERTICAL AXIS LABEL

      // DRAW VERTICAL AXIS
      ctx_summary_sway.strokeStyle = 'rgba(102, 102, 102, 1.0)';
      ctx_summary_sway.lineWidth = 1;
      ctx_summary_sway.moveTo((chart_pad_left + .5), ((chart_pad_top) + .5));
      ctx_summary_sway.lineTo((chart_pad_left + .5), ((canvas_summary_sway.height - chart_pad_bottom) + .5));
      ctx_summary_sway.stroke();

      ctx_summary_errors.strokeStyle = 'rgba(102, 102, 102, 1.0)';
      ctx_summary_errors.lineWidth = 1;
      ctx_summary_errors.moveTo((chart_pad_left + .5), ((chart_pad_top) + .5));
      ctx_summary_errors.lineTo((chart_pad_left + .5), ((canvas_summary_errors.height - chart_pad_bottom) + .5));
      ctx_summary_errors.stroke();
      // END DRAW VERTICAL AXIS

      // DRAW SWAY VERTICAL AXIS DATA POINTS
      ctx_summary_sway.font = "normal 12px sans-serif";
      ctx_summary_sway.textAlign = "right";
      ctx_summary_sway.textBaseline = "middle";
      ctx_summary_sway.strokeStyle = 'rgba(102, 102, 102, 1.0)';
      ctx_summary_sway.fillStyle = 'rgba(102, 102, 102, 1.0)';
      //ctx_summary_sway.fillText(Math.floor(volumes_array[0]).toFixed(3), (chart_pad_left - 14), (Math.floor(Math.abs(volumes_array[0]) - (volumes_array[0])) * px_per_tick_sway) + chart_pad_top);
      // TOP DATA POINT
      ctx_summary_sway.fillText(Math.ceil(volumes_array[volumes_array.length - 1]).toFixed(1), (chart_pad_left - 14), ((volumes_range * 0) * px_per_tick_sway) + chart_pad_top);
      ctx_summary_sway.moveTo((chart_pad_left + .5), ((chart_pad_top) + .5));
      ctx_summary_sway.lineTo((chart_pad_left + .5) - 5, ((chart_pad_top) + .5));

      // .25 DATA POINT
      ctx_summary_sway.fillText((Math.ceil(volumes_array[volumes_array.length - 1]) - (volumes_range * .25)).toFixed(1), (chart_pad_left - 14), ((volumes_range * .25) * px_per_tick_sway) + chart_pad_top);
      ctx_summary_sway.moveTo((chart_pad_left + .5), (Math.ceil((volumes_range * .25) * px_per_tick_sway) + .5) + chart_pad_top);
      ctx_summary_sway.lineTo((chart_pad_left + .5) - 5, (Math.ceil((volumes_range * .25) * px_per_tick_sway) + .5) + chart_pad_top);

      // .5 DATA POINT
      ctx_summary_sway.fillText((Math.ceil(volumes_array[volumes_array.length - 1]) - (volumes_range * .5)).toFixed(1), (chart_pad_left - 14), ((volumes_range * .5) * px_per_tick_sway) + chart_pad_top);
      ctx_summary_sway.moveTo((chart_pad_left + .5), (Math.ceil((volumes_range * .5) * px_per_tick_sway) + .5) + chart_pad_top);
      ctx_summary_sway.lineTo((chart_pad_left + .5) - 5, (Math.ceil((volumes_range * .5) * px_per_tick_sway) + .5) + chart_pad_top);

      // .75 DATA POINT
      ctx_summary_sway.fillText((Math.ceil(volumes_array[volumes_array.length - 1]) - (volumes_range * .75)).toFixed(1), (chart_pad_left - 14), ((volumes_range * .75) * px_per_tick_sway) + chart_pad_top);
      ctx_summary_sway.moveTo((chart_pad_left + .5), (Math.ceil((volumes_range * .75) * px_per_tick_sway) + .5) + chart_pad_top);
      ctx_summary_sway.lineTo((chart_pad_left + .5) - 5, (Math.ceil((volumes_range * .75) * px_per_tick_sway) + .5) + chart_pad_top);

      // BOTTOM DATA POINT
      ctx_summary_sway.fillText(Math.floor(volumes_array[0]).toFixed(1), (chart_pad_left - 14), ((canvas_summary_sway.height - chart_pad_bottom) + .5));
      ctx_summary_sway.moveTo((chart_pad_left + .5), ((canvas_summary_sway.height - chart_pad_bottom) + .5));
      ctx_summary_sway.lineTo((chart_pad_left + .5) - 5, ((canvas_summary_sway.height - chart_pad_bottom) + .5));
      // END DRAW SWAY VERTICAL AXIS DATA POINTS

      // DRAW ERRORS VERTICAL AXIS DATA POINTS
      ctx_summary_errors.font = "normal 12px sans-serif";
      ctx_summary_errors.textAlign = "right";
      ctx_summary_errors.textBaseline = "middle";
      ctx_summary_errors.strokeStyle = 'rgba(102, 102, 102, 1.0)';
      ctx_summary_errors.fillStyle = 'rgba(102, 102, 102, 1.0)';
      // TOP DATA POINT
      ctx_summary_errors.fillText((errors_array[errors_array.length - 1]), (chart_pad_left - 14), ((errors_range * 0) * px_per_tick_errors) + chart_pad_top);
      ctx_summary_errors.moveTo((chart_pad_left + .5), ((chart_pad_top) + .5));
      ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, ((chart_pad_top) + .5));

      // IF ERRORS RANGE GT 1
      if(errors_range > 1){
        if(errors_range%2 == 0){// IF RANGE IS EVEN
          // .5 DATA POINT
          ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - (errors_range * .5)), (chart_pad_left - 14), ((errors_range * .5) * px_per_tick_errors) + chart_pad_top);
          ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil((errors_range * .5) * px_per_tick_errors) + .5) + chart_pad_top);
          ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil((errors_range * .5) * px_per_tick_errors) + .5) + chart_pad_top);
          if((errors_range*.5)%2 == 0){
            // .25 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - (errors_range * .25)), (chart_pad_left - 14), ((errors_range * .25) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil((errors_range * .25) * px_per_tick_errors) + .5) + chart_pad_top);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil((errors_range * .25) * px_per_tick_errors) + .5) + chart_pad_top);
            // .75 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - (errors_range * .75)), (chart_pad_left - 14), ((errors_range * .75) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil((errors_range * .75) * px_per_tick_errors) + .5) + chart_pad_top);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil((errors_range * .75) * px_per_tick_errors) + .5) + chart_pad_top);
          }
        }else{// RANGE IS ODD
          if(errors_range%5 == 0){// 5s
            // .33 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - Math.ceil(errors_range * .33)), (chart_pad_left - 14), (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top + .5);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top + .5);
            // .66 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - Math.ceil(errors_range * .66)), (chart_pad_left - 14), (Math.ceil(errors_range * .66) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil(errors_range * .66) * px_per_tick_errors) + chart_pad_top + .5);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil(errors_range * .66) * px_per_tick_errors) + chart_pad_top + .5);
          }else if(errors_range%3 == 0){// 3s
            // .33 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - Math.ceil(errors_range * .33)), (chart_pad_left - 14), (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top + .5);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top + .5);
            // .66 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - Math.ceil(errors_range * .66)), (chart_pad_left - 14), (Math.ceil(errors_range * .66) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil(errors_range * .66) * px_per_tick_errors) + chart_pad_top + .5);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil(errors_range * .66) * px_per_tick_errors) + chart_pad_top + .5);
          }else{// PRIMES
            // .33 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - Math.ceil(errors_range * .33)), (chart_pad_left - 14), (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top + .5);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.ceil(errors_range * .33) * px_per_tick_errors) + chart_pad_top + .5);
            // .66 DATA POINT
            ctx_summary_errors.fillText((errors_array[errors_array.length - 1] - Math.floor(errors_range * .66)), (chart_pad_left - 14), (Math.floor(errors_range * .66) * px_per_tick_errors) + chart_pad_top);
            ctx_summary_errors.moveTo((chart_pad_left + .5), (Math.floor(errors_range * .66) * px_per_tick_errors) + chart_pad_top + .5);
            ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, (Math.floor(errors_range * .66) * px_per_tick_errors) + chart_pad_top + .5);
          }
        }// END IF RANGE IS EVEN
      }// END IF ERRORS RANGE GT 1

      // BOTTOM DATA POINT
      ctx_summary_errors.fillText((errors_array[0]), (chart_pad_left - 14), ((canvas_summary_errors.height - chart_pad_bottom) + .5));
      ctx_summary_errors.moveTo((chart_pad_left + .5), ((canvas_summary_errors.height - chart_pad_bottom) + .5));
      ctx_summary_errors.lineTo((chart_pad_left + .5) - 5, ((canvas_summary_errors.height - chart_pad_bottom) + .5));
      // END DRAW ERRORS VERTICAL AXIS DATA POINTS
      // DRAW HORIZONTAL AXIS LABEL
      ctx_summary_sway.font = "normal 12px sans-serif";
      ctx_summary_sway.textAlign = "center";
      ctx_summary_sway.textBaseline = "bottom";
      ctx_summary_sway.fillStyle = 'rgba(0, 0, 0, 1.0)';
      ctx_summary_sway.fillText("Stance", canvas_summary_sway.width * .5, canvas_summary_sway.height);

      ctx_summary_errors.font = "normal 12px sans-serif";
      ctx_summary_errors.textAlign = "center";
      ctx_summary_errors.textBaseline = "bottom";
      ctx_summary_errors.fillStyle = 'rgba(0, 0, 0, 1.0)';
      ctx_summary_errors.fillText("Stance", canvas_summary_errors.width * .5, canvas_summary_errors.height);
      // END DRAW HORIZONTAL AXIS LABEL

      // DRAW HORIZONTAL AXIS
      ctx_summary_sway.strokeStyle = 'rgba(102, 102, 102, 1.0)';
      ctx_summary_sway.lineWidth = 1;
      ctx_summary_sway.moveTo((chart_pad_left + .5), ((canvas_summary_sway.height - chart_pad_bottom) + .5));
      ctx_summary_sway.lineTo(((canvas_summary_sway.width - chart_pad_right) + .5), ((canvas_summary_sway.height - chart_pad_bottom) + .5));
      ctx_summary_sway.stroke();

      ctx_summary_errors.strokeStyle = 'rgba(102, 102, 102, 1.0)';
      ctx_summary_errors.lineWidth = 1;
      ctx_summary_errors.moveTo((chart_pad_left + .5), ((canvas_summary_errors.height - chart_pad_bottom) + .5));
      ctx_summary_errors.lineTo(((canvas_summary_errors.width - chart_pad_right) + .5), ((canvas_summary_errors.height - chart_pad_bottom) + .5));
      ctx_summary_errors.stroke();
      // END DRAW HORIZONTAL AXIS

      // DRAW ERROR DATA
      data.chart_colors = [
      'rgb(54,179,0)',
      'rgb(255,0,0)',
      'rgb(255,153,0)',
      'rgb(0,204,255)',
      'rgb(0,0,255)',
      'rgb(102,0,102)',
      'rgb(0,0,0)',
      'rgb(102,102,102)',
      'rgb(153,153,153)',
      'rgb(204,204,204)'
      ];
      var is_first = true;
      var legend_html = "";
      // FOR ASSESSMENTS
      ctx_summary_errors.lineWidth = 3;
      for(i = 0; i < data.assessments.length; i++){
        ctx_summary_errors.fillStyle = data.chart_colors[i];
        ctx_summary_errors.strokeStyle = data.chart_colors[i];
        is_first = true;
        legend_html += '<div class="legend_rect" style="background-color: ';
        legend_html += data.chart_colors[i];
        legend_html += ';">&nbsp;</div>';
        legend_html += data.assessments[i].complete_time.split("T")[0];
        legend_html += '<br>';
        if(data.assessments[i].baseline == true){
          legend_html += 'BASELINE';
        }else{
          legend_html += 'FOLLOW-UP';
        }
        legend_html += '<div class="clear-both">&nbsp;</div>';
        legend_html += '<br>';
        // FOR STANCES - LINES
        for(j = 0; j < 6; j++){
          if(data.assessments[i].bess_test_indices[j] > -1){
            if(is_first == true){
              ctx_summary_errors.beginPath();
              ctx_summary_errors.moveTo(stance_x_array[j], (chart_height - (data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].error_count * px_per_tick_errors) + chart_pad_top));
              is_first = false;
            }else{
              ctx_summary_errors.lineTo(stance_x_array[j], (chart_height - (data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].error_count * px_per_tick_errors) + chart_pad_top));
              ctx_summary_errors.stroke();
            }
          }
        }// END FOR STANCES - LINES
        // FOR STANCES - POINTS
        for(j = 0; j < 6; j++){
          if(data.assessments[i].bess_test_indices[j] > -1){
            ctx_summary_errors.beginPath();
            ctx_summary_errors.arc(stance_x_array[j],(chart_height - (data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].error_count * px_per_tick_errors) + chart_pad_top),5,0,2*Math.PI);
            ctx_summary_errors.fill();
            /*data.hotspots_errors[i] = {

              };*/
          }
        }// END FOR STANCES - POINTS
      }// END FOR ASSESSMENTS
      $("#legend").html(legend_html);
      // END DRAW ERROR DATA
      // END DRAW SUMMARIES
    }// END IF SHOW SUMMARIES
    this.drawEllipses(data);
  }// END INITIALIZE ELLIPSE DATA

  drawEllipses(data){
    // FOR ASSESSMENTS
    for(let i = 0; i < data.assessments.length; i++){
      // FOR STANCES
      for(let j = 0; j < 6; j++){
        // IF DATA AVAILABLE FOR STANCE
        if(data.assessments[i].bess_test_indices[j] > -1){
          this.drawEllipse(i, j, data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ml_radius, data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].tr_radius, data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].ap_radius, data.assessments[i].bess_tests[data.assessments[i].bess_test_indices[j]].readings_array, data);
        }
        // END IF DATA AVAILABLE FOR STANCE
      }// END FOR STANCES
    }// END FOR ASSESSMENTS
  }

  drawEllipse(assessment, stance, ml_radius, tr_radius, ap_radius, readings_array, data){
    var canvas = $('#ellipse' + this.selector_id + '_' + assessment + '_' + stance)[0];
    var ctx;
    // REGISTER DYNAMIC CANVAS WITH excanvas.js for IE
    // if (!isCanvasSupported()) { // ie IE
    //   G_vmlCanvasManager.initElement(canvas);
    // }
    // END REGISTER DYNAMIC CANVAS WITH excanvas.js for IE

    canvas.width = 1;
    canvas.height = 1;
    canvas.width = data.canvas_width;
    canvas.height = data.canvas_height;
    ctx = canvas.getContext('2d');

    var img;
    var i;
    var x;
    var y;
    var z;
    var comp = 0;//parseInt($('#comparison').val());
    var px_per_unit = 0;
    if(comp == 0){// COMPARE BY STANCE
      px_per_unit = data.px_per_stance[stance];
    }else if(comp == 1){// COMPARE BY ASSESSMENT
      px_per_unit = data.assessments[assessment].px_per_assessment;
    }else{// COMPARE BY ALL
      px_per_unit = data.px_per_all;
    }
    var prism_width = data.canvas_width - data.axes_padding;
    // ap and ml x positions for cube
    var x1 = Math.floor((prism_width * (data.ap_max_radius_stance[stance] / (data.ap_max_radius_stance[stance] + data.ml_max_radius_stance[stance]))) + (data.axes_padding * .5)) + .5;
    //var x2 = Math.floor(prism_width - x1 + (data.axes_padding * .5));
    var x2 = Math.floor(data.canvas_width - x1) + .5;

    // CALCULATE PRISM ANGLES
    var o1 = Math.ceil(data.canvas_height * .63);
    var o2 = Math.ceil(data.canvas_height * .95);
    var a1 = x1;
    var a2 = Math.ceil(data.canvas_width * .92);
    var opp = o2 - o1;
    var adj = a2 - a1;
    var ml_angle = Math.round(Math.atan(opp/adj) * 1000) / 1000;// *180/Math.PI
    a2 = a1;
    a1 = Math.ceil(data.axes_padding * .5);
    o1 = Math.ceil(data.canvas_height * .83);
    opp = o2 - o1;
    adj = a2 - a1;
    var ap_angle = Math.round(Math.atan(opp/adj) * 1000) / 1000// *180/Math.PI
    // END CALCULATE PRISM ANGLES

    // DRAW CUBE BOTTOM
    ctx.strokeStyle = 'rgba(220, 220, 220, 1.0)';
    ctx.lineWidth = 1;
    ctx.fillStyle = 'rgba(250, 250, 250, 1.0)';
    ctx.beginPath();
    ctx.moveTo((Math.ceil(data.axes_padding * .5) + .5), (Math.ceil(data.canvas_height * .83) + .5));
    ctx.lineTo(x1, (Math.ceil(data.canvas_height * .95) + .5));
    ctx.lineTo((Math.ceil(data.canvas_width * .92) + .5), (Math.ceil(data.canvas_height * .63) + .5));
    ctx.lineTo(x2, (Math.ceil(data.canvas_height * .51) + .5));
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    // END DRAW CUBE BOTTOM

    // DRAW CUBE BACK
    ctx.beginPath();
    ctx.moveTo((Math.ceil(data.axes_padding * .5) + .5), (Math.ceil(data.canvas_height * .35) + .5));
    ctx.lineTo((Math.ceil(data.axes_padding * .5) + .5), (Math.ceil(data.canvas_height * .83) + .5));
    ctx.lineTo(x2, (Math.ceil(data.canvas_height * .51) + .5));
    ctx.lineTo(x2, (Math.ceil(data.canvas_height * .06) + .5));
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    // END DRAW CUBE BACK

    // DRAW CUBE BACK SIDE
    ctx.beginPath();
    ctx.moveTo(x2, (Math.ceil(data.canvas_height * .06) + .5));
    ctx.lineTo(x2, (Math.ceil(data.canvas_height * .51) + .5));
    ctx.lineTo((Math.ceil(data.canvas_width * .92) + .5), (Math.ceil(data.canvas_height * .63) + .5));
    ctx.lineTo((Math.ceil(data.canvas_width * .92) + .5), (Math.ceil(data.canvas_height * .17) + .5));
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    // END DRAW CUBE BACK SIDE

    // DRAW SPHERE IMAGE
    ctx.save();
    ctx.translate((data.canvas_width * .5), (data.canvas_height * .5));

    // GET ANGLE
    //data.major_axis_stance[j]
    var ellipse_angle = 0;
    if(ap_radius == ml_radius){
      ellipse_angle = 0;
    }else if(ap_radius > ml_radius){
      //ellipse_angle = Math.ceil((ap_radius / (ap_radius + ml_radius)) * data.perspective_angle);
      //ellipse_angle = Math.round(((ap_radius / (ap_radius + ml_radius)) * ap_angle) * 1000) / 1000;
      ellipse_angle = ap_angle;
    }else{
      //ellipse_angle = 0 - Math.ceil((ml_radius / (ap_radius + ml_radius)) * data.perspective_angle);
      //ellipse_angle = 0 - Math.round(((ml_radius / (ap_radius + ml_radius)) * ml_angle) * 1000) / 1000;
      ellipse_angle = 0 - ml_angle;
    }
    /*if(data.major_axis_stance[stance] == "ml"){
      ellipse_angle = 0 - ml_angle;
    }else if(data.major_axis_stance[stance] == "ap"){
      ellipse_angle = ap_angle;
    }else{
      ellipse_angle = 0;
    }*/

    // ROTATE IF NOT IE < 9
    //if(!!isCanvasSupported()){
      //ctx.rotate(ellipse_angle*Math.PI/180);
      //ctx.rotate(ellipse_angle);
      ctx.lineWidth = .5;
    //}else{
      // USE PRE-ROTATED IMAGE FOR IE < 9
      //$("#sphere").attr("src","sphereWireframeIElt9.png");
     // ctx.lineWidth = 1;
    //}
    img = $("#sphere")[0];
    // END ROTATE IF NOT IE < 9

    // IF SHOW PLOT
    //if($('#show_plot').is(':checked')){
      // DRAW READINGS
      ctx.strokeStyle = 'rgba(0, 0, 0, 1)';
      ctx.beginPath();
      ctx.moveTo(0, 0);
      // FOR READINGS ARRAY
      for(i = 1; i < data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array.length; i++){
        /*x = parseInt(data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array[i][1] * data.px_readings_per_stance[stance]);//ML
        y = parseInt(data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array[i][0] * data.px_readings_per_stance[stance]);//AP
        z = parseInt(data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array[i][2] * data.px_readings_per_stance[stance]);//TR*/
        z = parseInt(data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array[i][0] * data.px_readings_per_stance[stance]);//ML
        x = parseInt(data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array[i][1] * data.px_readings_per_stance[stance]);//AP
        y = parseInt(data.assessments[assessment].bess_tests[data.assessments[assessment].bess_test_indices[stance]].readings_array[i][2] * data.px_readings_per_stance[stance]);//TR

        /*ctx.lineTo(
        Math.floor(Math.cos(ml_angle) * x) +
        Math.floor(Math.cos(ap_angle) * y),
        Math.floor(z) +
        Math.floor(Math.sin(ml_angle) * x) +
        Math.floor(Math.sin(ap_angle) * y)
        );*/
        ctx.lineTo(
        Math.floor(Math.cos(ml_angle) * x) +
        Math.floor(Math.cos(ap_angle) * z),
        Math.floor(y) +
        Math.floor(Math.sin(ml_angle) * x) +
        Math.floor(Math.sin(ap_angle) * z)
        );
      }// END FOR READINGS ARRAY
      ctx.stroke();
      // END DRAW READINGS
    //}// END IF SHOW PLOT
    /*ctx.drawImage(img,
    (0) - Math.floor(((ml_radius + ap_radius) * .5) * px_per_unit),
    (0) - Math.floor((tr_radius) * px_per_unit),
    Math.floor((ml_radius + ap_radius) * px_per_unit),
    Math.floor((tr_radius * 2) * px_per_unit));*/
    var ew;
    if(ap_radius >= ml_radius){
      ew = ap_radius;
    }else{
      ew = ml_radius;
    }
    ctx.drawImage(img,
    (0) - Math.floor((ew) * px_per_unit),
    (0) - Math.floor((tr_radius) * px_per_unit),
    Math.floor((ew * 2) * px_per_unit),
    Math.floor((tr_radius * 2) * px_per_unit));
    ctx.restore();
    // END DRAW SPHERE IMAGE

    // DRAW CUBE TOP
    ctx.strokeStyle = 'rgba(220, 220, 220, 1.0)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo((Math.ceil(data.axes_padding * .5) + .5), (Math.ceil(data.canvas_height * .35) + .5));
    ctx.lineTo(x1, (Math.ceil(data.canvas_height * .46) + .5));
    ctx.lineTo((Math.ceil(data.canvas_width * .92) + .5), (Math.ceil(data.canvas_height * .17) + .5));
    ctx.lineTo(x2, (Math.ceil(data.canvas_height * .06) + .5));
    ctx.closePath();
    ctx.stroke();
    // END DRAW CUBE TOP

    // DRAW CUBE FRONT EDGE
    ctx.moveTo(x1, (Math.ceil(data.canvas_height * .46) + .5));
    ctx.lineTo(x1, (Math.ceil(data.canvas_height * .95) + .5));
    ctx.stroke();
    // END DRAW CUBE FRONT EDGE

    // DRAW AXES LABELS
    ctx.font="14px sans-serif";
    ctx.fillStyle = 'rgba(191, 191, 191, 1.0)';
    ctx.fillStyle = 'rgba(0, 0, 220, 1.0)';
    ctx.fillText("ML", data.canvas_width * .8, data.canvas_height - 0);
    ctx.fillStyle = 'rgba(0, 220, 0, 1.0)';
    ctx.fillText("AP", 16, data.canvas_height - 0);
    ctx.save();
    ctx.rotate(-90*Math.PI/180);
    ctx.fillStyle = 'rgba(220, 0, 0, 1.0)';
    ctx.fillText("TR", 0 - (data.canvas_height * .65), 14);
    ctx.restore();
    // END DRAW AXES LABELS

    // FPO DRAW AXES
    /*ctx.strokeStyle = 'rgba(220, 0, 0, 1.0)';
    ctx.lineWidth = 2;
    ctx.save();
    ctx.translate((data.canvas_width * .5), (data.canvas_height * .5));
    ctx.beginPath();
    ctx.moveTo(0, (0) - Math.floor((tr_radius) * px_per_unit));
    ctx.lineTo(0, (0) + Math.floor((tr_radius) * px_per_unit));
    ctx.stroke();
    ctx.restore();

    ctx.strokeStyle = 'rgba(0, 220, 0, 1.0)';
    ctx.lineWidth = 2;
    ctx.save();
    ctx.translate((data.canvas_width * .5), (data.canvas_height * .5));
    ctx.rotate(ap_angle);
    ctx.beginPath();
    ctx.moveTo((0) - Math.floor((ap_radius) * px_per_unit), 0);
    ctx.lineTo((0) + Math.floor((ap_radius) * px_per_unit), 0);
    ctx.stroke();
    ctx.restore();

    ctx.strokeStyle = 'rgba(0, 0, 220, 1.0)';
    ctx.lineWidth = 2;
    ctx.save();
    ctx.translate((data.canvas_width * .5), (data.canvas_height * .5));
    ctx.rotate(0 - ml_angle);
    ctx.beginPath();
    ctx.moveTo((0) - Math.floor((ml_radius) * px_per_unit), 0);
    ctx.lineTo((0) + Math.floor((ml_radius) * px_per_unit), 0);
    ctx.stroke();
    ctx.restore();
    ctx.strokeStyle = 'rgba(220, 220, 220, 1.0)';
    ctx.lineWidth = 1;*/
    // END FPO DRAW AXES

  }// END DRAW ELLIPSE

}

export default C4BessEllipse;
